module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pallet/pallet.component.css
// module id = ./src/app/pallet/pallet.component.css
// module chunks = main